import { AreaOfInterestDto, UserAreaOfInterestItemDto } from '@/api/generated';
import WinkingRobotSvg from '@/assets/WinkingRobotSvg.svg';
import { TextAreaField } from '@/components/form/TextAreaField.comp.tsx';
import { generateNonCachableImageSrc } from '@/utils/generateNonCachableImageSrc.util.ts';
import { UserPersonalDataProperties } from '@/views/process/pages/personalDataForm/usePersonalDataForm.validation.ts';
import { TFunction } from 'i18next';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';

import { AreaOfInterestPrioritySelector } from '../AreaOfInterestPrioritySelector';

interface Props {
  activeAreaOfInterests: AreaOfInterestDto[];
  formMethods: UseFormReturn<UserPersonalDataProperties>;
  handleAreasChange: (areas: UserAreaOfInterestItemDto[]) => void;
  handleTextAreaChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  prioritizedAreas: UserAreaOfInterestItemDto[];
  t: TFunction;
}

export const AreasOfInterestSection: React.FC<Props> = ({
  activeAreaOfInterests,
  formMethods,
  handleAreasChange,
  handleTextAreaChange,
  prioritizedAreas,
  t,
}) => {
  const {
    formState: { errors },
    register,
  } = formMethods;

  return (
    <div className="flex flex-wrap lg:col-span-3 gap-3 mt-2">
      <div className="w-full">
        <h3 className="font-semibold mb-2">{t('areasHeading')}</h3>
        <div className="flex justify-content-between align-items-start gap-5">
          <div className="flex-grow-1">
            <AreaOfInterestPrioritySelector
              activeAreaOfInterests={activeAreaOfInterests ?? []}
              onChange={handleAreasChange}
              value={prioritizedAreas}
            />
          </div>
          <div className="max-w-[100px] md:max-w-[140px] m-auto">
            <img
              alt="winking-robot"
              className="w-100"
              src={generateNonCachableImageSrc(WinkingRobotSvg)}
            />
          </div>
        </div>
      </div>
      <TextAreaField
        errors={errors}
        label={t('fields.areaDescription.label')}
        maxLength={500}
        name="areaOfInterestsUserInput"
        onChange={handleTextAreaChange}
        placeholder={t('fields.areaDescription.placeholder')}
        register={register}
        required
        rows={3}
      />
    </div>
  );
};
